import apiClient from "./axios"

export const getPrayerReminderSettings = async (params = {}) => {
  const { data } = await apiClient.get("/prayer-reminders", { params })
  return data
}

export const getPrayerReminderMeta = async () => {
  const { data } = await apiClient.get("/prayer-reminders/meta")
  return data
}

export const getPrayerReminderSetting = async id => {
  const { data } = await apiClient.get(`/prayer-reminders/${id}`)
  return data
}

export const createPrayerReminderSetting = async payload => {
  const { data } = await apiClient.post("/prayer-reminders", payload)
  return data
}

export const editPrayerReminderSetting = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/prayer-reminders/${id}`, payload)
  return data
}

export const deletePrayerReminderSetting = async id => {
  const { data } = await apiClient.delete(`/prayer-reminders/${id}`)
  return data
}
